import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faEye,
  faEyeSlash,
  faClipboard,
  faGear,
  faTimes,
  faBars,
  faUser,
  faChevronLeft,
  faChevronRight,
  faUsers,
  faSearch,
  faPlusCircle,
  faTrash,
  faFolderOpen,
  faPen,
  faSortUp,
  faSortDown,
  faSort,
  faFilter,
  faDownload,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronDown,
  faChevronUp,
  faUpload,
  faArrowLeft,
  faCalendar,
  faAddressBook,
  faBell,
  faCarSide,
  faWrench,
  faAddressCard,
  faFolder,
  faFilePdf,
  faFileExcel,
  faFileImage,
  faFileWord,
  faEllipsis,
  faPlane,
  faDollar,
  faChartBar,
  faSackXmark,
  faHandHoldingDollar,
  faMoneyBillTransfer,
  faMapLocation,
  faUserShield,
  faWarehouse,
  faCalendarAlt,
  faPlus,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";

import { faMoon, faSun } from "@fortawesome/free-regular-svg-icons";

library.add(
  faClipboard,
  faEye,
  faEyeSlash,
  faGear,
  faTimes,
  faSun,
  faMoon,
  faBars,
  faUser,
  faChevronLeft,
  faChevronRight,
  faUsers,
  faSearch,
  faPlusCircle,
  faTrash,
  faFolderOpen,
  faPen,
  faSortUp,
  faSortDown,
  faSort,
  faFilter,
  faDownload,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronDown,
  faChevronUp,
  faUpload,
  faArrowLeft,
  faCalendar,
  faAddressBook,
  faEye,
  faBell,
  faCarSide,
  faWrench,
  faAddressCard,
  faFolderOpen,
  faFolder,
  faFilePdf,
  faFileExcel,
  faFileImage,
  faFileWord,
  faEllipsis,
  faUpload,
  faPlane,
  faDollar,
  faChartBar,
  faSackXmark,
  faHandHoldingDollar,
  faMoneyBillTransfer,
  faMapLocation,
  faUserShield,
  faWarehouse,
  faCalendarAlt,
  faPlus,
  faTasks
);
